import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateUserPrimaryPlanId } from '../store/users/actions';

import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

export function UserPrimaryPlan({ plans, updateUserPrimaryPlanId, user }) {
  const assignedPlans = plans.filter(plan => plan.users.some(planUser => planUser.id === user.id));

  return (
    <ManagedInput
      type="select"
      value={user.primaryPlanId}
      onValueChange={value => updateUserPrimaryPlanId(user, value ? parseInt(value) : null)}
    >
      <Options
        labelName="name"
        options={[{ name: 'None', id: null }, ...assignedPlans]}
        valueName="id"
      />
    </ManagedInput>
  );
}

UserPrimaryPlan.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired),
  })).isRequired,
  updateUserPrimaryPlanId: PropTypes.func.isRequired,
  user: PropTypes.shape({
    primaryPlanId: PropTypes.number,
  }).isRequired,
};

const mapStateToProps = state => ({
  plans: state.plans,
});

const mapDispatchToProps = {
  updateUserPrimaryPlanId,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPrimaryPlan);
